var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSpecialStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-06",
    clipPath: "url(#clip0_6116_52553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.9987 14.6668V11.3335M2.9987 4.66683V1.3335M1.33203 3.00016H4.66536M1.33203 13.0002H4.66536M8.66536 2.00016L7.50925 5.00607C7.32124 5.49489 7.22723 5.7393 7.08105 5.94489C6.95149 6.12709 6.7923 6.28629 6.61009 6.41585C6.4045 6.56203 6.16009 6.65604 5.67127 6.84404L2.66536 8.00016L5.67127 9.15628C6.16009 9.34429 6.4045 9.43829 6.61009 9.58448C6.7923 9.71404 6.95149 9.87323 7.08105 10.0554C7.22723 10.261 7.32124 10.5054 7.50925 10.9943L8.66537 14.0002L9.82148 10.9943C10.0095 10.5054 10.1035 10.261 10.2497 10.0554C10.3792 9.87323 10.5384 9.71404 10.7206 9.58448C10.9262 9.43829 11.1706 9.34429 11.6595 9.15628L14.6654 8.00016L11.6595 6.84404C11.1706 6.65604 10.9262 6.56203 10.7206 6.41585C10.5384 6.28629 10.3792 6.12709 10.2497 5.94489C10.1035 5.7393 10.0095 5.49489 9.82148 5.00607L8.66536 2.00016Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6116_52553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpecialStar);
export default __webpack_public_path__ + "static/media/ic-special-star.c5089d6bf2241fb6b71f32889ddc0aa4.svg";
export { ForwardRef as ReactComponent };